module.exports = __webpack_public_path__ + "img/切片-45.dcda8bed.jpg";